import TESpinner from './TESpinner'

export default TESpinner
